import { DOCUMENT_TYPE } from '@constants';
import { AssetTypesEnum, LenderDocumentTypeEnum, SelectOption } from '@types';
import { getAssetSpecificContent } from '@utils';

export const ASSET_DOCUMENT_TYPES = [
  LenderDocumentTypeEnum.ASSET_BACK,
  LenderDocumentTypeEnum.ASSET_FRONT,
  LenderDocumentTypeEnum.ASSET_LEFT,
  LenderDocumentTypeEnum.ASSET_RIGHT,
  LenderDocumentTypeEnum.MARINE_BACK,
  LenderDocumentTypeEnum.MARINE_FRONT,
  LenderDocumentTypeEnum.MARINE_LEFT,
  LenderDocumentTypeEnum.MARINE_RIGHT,
  LenderDocumentTypeEnum.INTERNAL_FRONT,
  LenderDocumentTypeEnum.INTERNAL_BACK,
  LenderDocumentTypeEnum.INTERNAL_BOOT,
  LenderDocumentTypeEnum.INTERNAL_LIVING_AREA,
  LenderDocumentTypeEnum.INTERNAL_KITCHEN,
  LenderDocumentTypeEnum.INTERNAL_SLEEPING_AREA,
  LenderDocumentTypeEnum.VIN,
  LenderDocumentTypeEnum.MARINE_HIN,
  LenderDocumentTypeEnum.MARINE_REGO_NUMBER,
  LenderDocumentTypeEnum.REGO_PLATE,
  LenderDocumentTypeEnum.SALE_DETAILS,
  LenderDocumentTypeEnum.ODOMETER,
  LenderDocumentTypeEnum.OPERATING_HOURS
] as const;

export const INVALID_DOCUMENTS_BY_ASSET: Record<
  AssetTypesEnum,
  LenderDocumentTypeEnum[]
> = {
  [AssetTypesEnum.CAR]: [
    LenderDocumentTypeEnum.INTERNAL_LIVING_AREA,
    LenderDocumentTypeEnum.INTERNAL_KITCHEN,
    LenderDocumentTypeEnum.INTERNAL_SLEEPING_AREA,
    LenderDocumentTypeEnum.OPERATING_HOURS,
    LenderDocumentTypeEnum.MARINE_HIN,
    LenderDocumentTypeEnum.MARINE_REGO_NUMBER,
    LenderDocumentTypeEnum.MARINE_REGO_CERT,
    LenderDocumentTypeEnum.MARINE_FRONT,
    LenderDocumentTypeEnum.MARINE_BACK,
    LenderDocumentTypeEnum.MARINE_LEFT,
    LenderDocumentTypeEnum.MARINE_RIGHT,
    LenderDocumentTypeEnum.MARINE_PPSR
  ],
  [AssetTypesEnum.MOTOR_CYCLE]: [
    LenderDocumentTypeEnum.INTERNAL_FRONT,
    LenderDocumentTypeEnum.INTERNAL_BACK,
    LenderDocumentTypeEnum.INTERNAL_BOOT,
    LenderDocumentTypeEnum.INTERNAL_LIVING_AREA,
    LenderDocumentTypeEnum.INTERNAL_KITCHEN,
    LenderDocumentTypeEnum.INTERNAL_SLEEPING_AREA,
    LenderDocumentTypeEnum.OPERATING_HOURS,
    LenderDocumentTypeEnum.MARINE_HIN,
    LenderDocumentTypeEnum.MARINE_REGO_NUMBER,
    LenderDocumentTypeEnum.MARINE_REGO_CERT,
    LenderDocumentTypeEnum.MARINE_FRONT,
    LenderDocumentTypeEnum.MARINE_BACK,
    LenderDocumentTypeEnum.MARINE_LEFT,
    LenderDocumentTypeEnum.MARINE_RIGHT,
    LenderDocumentTypeEnum.MARINE_PPSR
  ],
  [AssetTypesEnum.CAMPERVAN]: [
    LenderDocumentTypeEnum.ODOMETER,
    LenderDocumentTypeEnum.INTERNAL_FRONT,
    LenderDocumentTypeEnum.INTERNAL_BACK,
    LenderDocumentTypeEnum.INTERNAL_BOOT,
    LenderDocumentTypeEnum.OPERATING_HOURS,
    LenderDocumentTypeEnum.MARINE_HIN,
    LenderDocumentTypeEnum.MARINE_REGO_NUMBER,
    LenderDocumentTypeEnum.MARINE_REGO_CERT,
    LenderDocumentTypeEnum.MARINE_FRONT,
    LenderDocumentTypeEnum.MARINE_BACK,
    LenderDocumentTypeEnum.MARINE_LEFT,
    LenderDocumentTypeEnum.MARINE_RIGHT,
    LenderDocumentTypeEnum.MARINE_PPSR
  ],
  [AssetTypesEnum.TRAILER]: [
    LenderDocumentTypeEnum.ODOMETER,
    LenderDocumentTypeEnum.INTERNAL_FRONT,
    LenderDocumentTypeEnum.INTERNAL_BACK,
    LenderDocumentTypeEnum.INTERNAL_BOOT,
    LenderDocumentTypeEnum.INTERNAL_LIVING_AREA,
    LenderDocumentTypeEnum.INTERNAL_KITCHEN,
    LenderDocumentTypeEnum.INTERNAL_SLEEPING_AREA,
    LenderDocumentTypeEnum.OPERATING_HOURS,
    LenderDocumentTypeEnum.MARINE_HIN,
    LenderDocumentTypeEnum.MARINE_REGO_NUMBER,
    LenderDocumentTypeEnum.MARINE_REGO_CERT,
    LenderDocumentTypeEnum.MARINE_FRONT,
    LenderDocumentTypeEnum.MARINE_BACK,
    LenderDocumentTypeEnum.MARINE_LEFT,
    LenderDocumentTypeEnum.MARINE_RIGHT,
    LenderDocumentTypeEnum.MARINE_PPSR
  ],
  [AssetTypesEnum.EQUIPMENT]: [
    LenderDocumentTypeEnum.INTERNAL_LIVING_AREA,
    LenderDocumentTypeEnum.INTERNAL_KITCHEN,
    LenderDocumentTypeEnum.INTERNAL_SLEEPING_AREA,
    LenderDocumentTypeEnum.MARINE_HIN,
    LenderDocumentTypeEnum.MARINE_REGO_NUMBER,
    LenderDocumentTypeEnum.MARINE_REGO_CERT,
    LenderDocumentTypeEnum.MARINE_FRONT,
    LenderDocumentTypeEnum.MARINE_BACK,
    LenderDocumentTypeEnum.MARINE_LEFT,
    LenderDocumentTypeEnum.MARINE_RIGHT,
    LenderDocumentTypeEnum.MARINE_PPSR
  ],
  [AssetTypesEnum.MARINE]: [
    LenderDocumentTypeEnum.VIN,
    LenderDocumentTypeEnum.REGO_PLATE,
    LenderDocumentTypeEnum.REGO_PAPERS,
    LenderDocumentTypeEnum.ODOMETER,
    LenderDocumentTypeEnum.ASSET_FRONT,
    LenderDocumentTypeEnum.ASSET_BACK,
    LenderDocumentTypeEnum.ASSET_LEFT,
    LenderDocumentTypeEnum.ASSET_RIGHT,
    LenderDocumentTypeEnum.INTERNAL_FRONT,
    LenderDocumentTypeEnum.INTERNAL_BACK,
    LenderDocumentTypeEnum.INTERNAL_BOOT,
    LenderDocumentTypeEnum.INTERNAL_LIVING_AREA,
    LenderDocumentTypeEnum.INTERNAL_KITCHEN,
    LenderDocumentTypeEnum.INTERNAL_SLEEPING_AREA,
    LenderDocumentTypeEnum.OPERATING_HOURS,
    LenderDocumentTypeEnum.NEVDIS,
    LenderDocumentTypeEnum.ROADWORTHY_CERT,
    LenderDocumentTypeEnum.ROADWORTHY_CERT_STATE,
    LenderDocumentTypeEnum.RAV,
    LenderDocumentTypeEnum.PPSR
  ],
  [AssetTypesEnum.MARINE_WITH_TRAILER]: [
    LenderDocumentTypeEnum.ODOMETER,
    LenderDocumentTypeEnum.INTERNAL_FRONT,
    LenderDocumentTypeEnum.INTERNAL_BACK,
    LenderDocumentTypeEnum.INTERNAL_BOOT,
    LenderDocumentTypeEnum.INTERNAL_LIVING_AREA,
    LenderDocumentTypeEnum.INTERNAL_KITCHEN,
    LenderDocumentTypeEnum.INTERNAL_SLEEPING_AREA,
    LenderDocumentTypeEnum.OPERATING_HOURS,
    LenderDocumentTypeEnum.ROADWORTHY_CERT,
    LenderDocumentTypeEnum.ROADWORTHY_CERT_STATE,
    LenderDocumentTypeEnum.RAV
  ]
};

type CategoryDefinition = {
  id: string;
  label: string | ((assetType: AssetTypesEnum) => string);
  documentTypes: readonly LenderDocumentTypeEnum[];
};

const DOCUMENT_CATEGORY_DEFINITIONS: CategoryDefinition[] = [
  {
    id: 'seller-identification',
    label: 'Seller Identification',
    documentTypes: [LenderDocumentTypeEnum.SELLER_ID]
  },
  {
    id: 'asset',
    label: (assetType) => getAssetSpecificContent(assetType).title,
    documentTypes: ASSET_DOCUMENT_TYPES
  },
  {
    id: 'ownership',
    label: 'Ownership Documents',
    documentTypes: [
      LenderDocumentTypeEnum.REGO_PAPERS,
      LenderDocumentTypeEnum.MARINE_REGO_CERT,
      LenderDocumentTypeEnum.OWNERSHIP_PROOF
    ]
  },
  {
    id: 'financial',
    label: 'Financial Documentation',
    documentTypes: [
      LenderDocumentTypeEnum.BANK_STATEMENTS,
      LenderDocumentTypeEnum.PAYOUT_LETTER
    ]
  },
  {
    id: 'roadworthy',
    label: 'Roadworthy / Safety Certificate',
    documentTypes: [
      LenderDocumentTypeEnum.ROADWORTHY_CERT_STATE,
      LenderDocumentTypeEnum.ROADWORTHY_CERT
    ]
  },
  {
    id: 'external-verifications',
    label: 'External Verifications',
    documentTypes: [
      LenderDocumentTypeEnum.PPSR,
      LenderDocumentTypeEnum.MARINE_PPSR,
      LenderDocumentTypeEnum.NEVDIS,
      LenderDocumentTypeEnum.RAV
    ]
  }
];

export type DocumentSelectionGroup = {
  id: string;
  label: string;
  options: SelectOption[];
};

const getAssetDocumentLabel = (
  option: SelectOption,
  assetType: AssetTypesEnum
): string => {
  const content = getAssetSpecificContent(assetType);

  switch (option.value) {
    case LenderDocumentTypeEnum.ASSET_FRONT:
      return `Photo ${content.lowerTitle} front`;
    case LenderDocumentTypeEnum.ASSET_BACK:
      return `Photo ${content.lowerTitle} back`;
    case LenderDocumentTypeEnum.ASSET_LEFT:
      return `Photo ${content.lowerTitle} ${content.sides.passenger.toLowerCase()}`;
    case LenderDocumentTypeEnum.ASSET_RIGHT:
      return `Photo ${content.lowerTitle} ${content.sides.driver.toLowerCase()}`;
    case LenderDocumentTypeEnum.MARINE_FRONT:
      return 'Photo watercraft front';
    case LenderDocumentTypeEnum.MARINE_BACK:
      return 'Photo watercraft back';
    case LenderDocumentTypeEnum.MARINE_LEFT:
      return 'Photo watercraft port side';
    case LenderDocumentTypeEnum.MARINE_RIGHT:
      return 'Photo watercraft starboard side';
    default:
      return option.label;
  }
};

export const getAvailableDocumentOptions = (
  assetType: AssetTypesEnum
): SelectOption[] => {
  const invalidDocuments = INVALID_DOCUMENTS_BY_ASSET[assetType] || [];

  return DOCUMENT_TYPE.filter(
    (option) =>
      !invalidDocuments.includes(option.value as LenderDocumentTypeEnum)
  ).map((option) => ({
    ...option,
    label: getAssetDocumentLabel(option, assetType)
  }));
};

export const getDocumentSelectionGroups = (
  assetType: AssetTypesEnum,
  options: SelectOption[] = getAvailableDocumentOptions(assetType)
): DocumentSelectionGroup[] =>
  DOCUMENT_CATEGORY_DEFINITIONS.map((category) => ({
    id: category.id,
    label:
      typeof category.label === 'function'
        ? category.label(assetType)
        : category.label,
    options: options.filter((option) =>
      category.documentTypes.includes(option.value as LenderDocumentTypeEnum)
    )
  })).filter((category) => category.options.length > 0);

const SELLER_ID_DEPENDENT_DOCUMENTS = new Set<LenderDocumentTypeEnum>([
  LenderDocumentTypeEnum.DRIVER_LICENCE_FRONT,
  LenderDocumentTypeEnum.DRIVER_LICENCE_BACK,
  LenderDocumentTypeEnum.FACE
]);

export const removeOrphanedIdentificationDocuments = (
  documents: LenderDocumentTypeEnum[]
): LenderDocumentTypeEnum[] => {
  const uniqueDocuments = Array.from(new Set(documents));

  return uniqueDocuments.includes(LenderDocumentTypeEnum.SELLER_ID)
    ? uniqueDocuments
    : uniqueDocuments.filter(
        (document) => !SELLER_ID_DEPENDENT_DOCUMENTS.has(document)
      );
};

export const filterDocumentsForAsset = (
  documents: LenderDocumentTypeEnum[],
  assetType: AssetTypesEnum
): LenderDocumentTypeEnum[] => {
  const availableDocuments = new Set<LenderDocumentTypeEnum>(
    getAvailableDocumentOptions(assetType).map(
      (option) => option.value as LenderDocumentTypeEnum
    )
  );

  return removeOrphanedIdentificationDocuments(
    documents.filter((document) => availableDocuments.has(document))
  );
};

export const filterLoadedDocumentsForAsset = (
  documents: LenderDocumentTypeEnum[],
  assetType: AssetTypesEnum
): LenderDocumentTypeEnum[] => {
  const invalidDocuments = new Set(INVALID_DOCUMENTS_BY_ASSET[assetType] || []);

  return removeOrphanedIdentificationDocuments(
    documents.filter((document) => !invalidDocuments.has(document))
  );
};

type TemplateDocumentConfig = {
  roadworthyByState?: boolean;
  roadworthyIfUnregistered?: boolean;
};

export const normalizeTemplateDocumentTypes = (
  documentTypes: LenderDocumentTypeEnum[] = [],
  inspectionConfig: TemplateDocumentConfig = {}
): LenderDocumentTypeEnum[] => {
  const normalized: LenderDocumentTypeEnum[] = documentTypes.filter(
    (document) => document !== LenderDocumentTypeEnum.ROADWORTHY_CERT
  );

  if (inspectionConfig.roadworthyByState) {
    normalized.push(LenderDocumentTypeEnum.ROADWORTHY_CERT_STATE);
  }
  if (inspectionConfig.roadworthyIfUnregistered) {
    normalized.push(LenderDocumentTypeEnum.ROADWORTHY_CERT);
  }

  return Array.from(new Set(normalized));
};

export const serializeTemplateDocumentSelection = (
  selectedDocuments: LenderDocumentTypeEnum[]
): {
  documentTypes: LenderDocumentTypeEnum[];
  roadworthyByState: boolean;
  roadworthyIfUnregistered: boolean;
} => {
  const normalizedSelection =
    removeOrphanedIdentificationDocuments(selectedDocuments);
  const roadworthyByState = normalizedSelection.includes(
    LenderDocumentTypeEnum.ROADWORTHY_CERT_STATE
  );
  const roadworthyIfUnregistered = normalizedSelection.includes(
    LenderDocumentTypeEnum.ROADWORTHY_CERT
  );
  const documentTypes: LenderDocumentTypeEnum[] = normalizedSelection.filter(
    (document) =>
      document !== LenderDocumentTypeEnum.ROADWORTHY_CERT_STATE &&
      document !== LenderDocumentTypeEnum.ROADWORTHY_CERT
  );

  if (roadworthyByState || roadworthyIfUnregistered) {
    documentTypes.push(LenderDocumentTypeEnum.ROADWORTHY_CERT);
  }

  return {
    documentTypes: Array.from(new Set(documentTypes)),
    roadworthyByState,
    roadworthyIfUnregistered
  };
};
